import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, List, Tooltip } from "@mui/material";
import { Close as IconClose } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import AutoComplete from "components/Custom/AutoComplete";
import TxtRow from "components/Custom/TxtRow";
import TxtBox from "components/Custom/TxtBox";
import SkeletonBox from "components/Custom/SkeletonBox";

import { ApiMasters } from "apihandlers//masters/masters";
import { ApiIndents } from "apihandlers//indent";
import { NOTIFY, FORMATS, CONFIG, API_CONFIG, GOPAL_SNACKS } from "common/config";
import { COLORS } from "common/colors";
import { LABELS, ERRORS, WARNINGS, SUCCESS } from "common/labels";

import { COMMON_JS } from "common/scripts";
import { DateFunctions } from "common/datefunctions";

const ApiMastersHandler = new ApiMasters();
const ApiIndentHandler = new ApiIndents();

const thumbnailImg = require("assets/images/pdf.png");
const TripPaymentForm = (props: any) => {
  const {
    defaultValues,
    setManageDialog,
    selectedRow,
    setSelectedRow,
    reloadGrid,
  } = props;

  const [loading, setLoading] = useState(true);
  const [tripPaymentFile, setTripPaymentFile] = useState<any>([]);
  const [customers, setCustomers] = useState<any>([]);
  const [drivers, setDrivers] = useState<any>([]);
  const [uploading, setUploading] = useState<boolean>(false);
  const [indentGroup, setIndentGroup] = useState<any>([]);
  const [chargesType, setChargesType] = useState<any>([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [mandatoryResults, setMandatoryResults] = useState<any>({});
  const [selectedDriver, setSelectedDriver] = useState<any>(
    selectedRow.id
      ? {
          id: selectedRow.driverId,
          label: selectedRow.driverName,
        }
      : {}
  );

  const customerIdRef: any = useRef();
  const indentIdRef: any = useRef();
  const chargedIdRef: any = useRef();
  const driverIdRef: any = useRef();

  useEffect(() => {
    if (loading) {
      getDrivers();
      if (selectedRow.id) {
        getUploadedFiles(selectedRow.id);
      }
    }
  }, [loading]);

  const getDrivers = () => {
    const args = {
      activeStatus: "true",
      shortMode: true,
    };
    ApiMastersHandler.getDrivers(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.fullName,
          };
        });
        setDrivers(list);
        getTripsList();
      }
    });
  };

  const getTripsList = () => {
    const args = {
      activeStatus: "true",
      minResponse: true,
    };
    ApiIndentHandler.getTripsList(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.indentNo,
            data: r,
          };
        });
        console.log("gettrip", list);
        setIndentGroup(list);
        getChargesList();
      }
    });
  };

  const getChargesList = () => {
    const args = {
      activeStatus: "true",
      minResponse: true,
    };
    ApiMastersHandler.getCharges(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.name,
          };
        });
        setChargesType(list);
        getCustomers();
      }
    });
  };

  const getCustomers = () => {
    const args = {
      activeStatus: "true",
      minResponse: true,
    };
    ApiMastersHandler.getTransporters(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.organizationName,
          };
        });
        setCustomers(list);
      }
    });
  };

  const manageRecord = () => {
    const indentId = indentIdRef.current.selectedValue.id;
    const paymentDate = (
      document.getElementById("paymentDate") as HTMLInputElement
    ).value.trim();
    const customerId = customerIdRef.current.selectedValue.id;
    const driverId = driverIdRef.current.selectedValue.id;
    const chargedId = chargedIdRef.current.selectedValue.id;
    const remarks = (
      document.getElementById("remarks") as HTMLInputElement
    ).value.trim();
    const amount = parseInt(
      (document.getElementById("amount") as HTMLInputElement).value.trim()
    );
    const refNo = (
      document.getElementById("refNo") as HTMLInputElement
    ).value.trim();
    let payment = document.querySelector(
      'input[name="transactionMode"]:checked'
    ) as HTMLInputElement;
    const paymentMode = payment ? payment.value : "";
    let op = document.querySelector(
      'input[name="transactionModeOfGopal"]:checked'
    ) as HTMLInputElement;
    const paymentModeOfGopal = op ? op.value : "";
    op = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;

    console.log("paymentModeOfGopal", paymentModeOfGopal);
    const activeStatus = op ? op.value : "";

    // Validations

    let errors = [];
    if (!indentId) {
      errors.push({
        id: "indentId",
        msg:
          "<span class='bold'>" +
          LABELS.TRIP +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    if (paymentDate == "") {
      errors.push({
        id: "paymentDate",
        msg:
          "<span class='bold'>" +
          LABELS.TRANSACTION_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!driverId) {
      errors.push({
        id: "driverId",
        msg:
          "<span class='bold'>" +
          LABELS.DRIVERS_NAME +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!chargedId) {
      errors.push({
        id: "chargedId",
        msg:
          "<span class='bold'>" +
          LABELS.CATEGORY +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    if (!amount) {
      errors.push({
        id: "amount",
        msg:
          "<span class='bold'>" +
          LABELS.AMMOUNT +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!GOPAL_SNACKS) {
      if (!paymentMode) {
        errors.push({
          id: "paymentMode",
          msg:
            "<span class='bold'>" +
            LABELS.TRANSACTION_MODE +
            "</span> " +
            WARNINGS.IS_A_REQUIRED_FIELD,
        });
      }
    }
    if (GOPAL_SNACKS) {
      if (!paymentModeOfGopal) {
        errors.push({
          id: "paymentModeOfGopal",
          msg:
            "<span class='bold'>" +
            LABELS.TRANSACTION_MODE_OF_GOPAL +
            "</span> " +
            WARNINGS.IS_A_REQUIRED_FIELD,
        });
      }
    }

    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      indentId,
      paymentDate,
      amount,
      remarks,
      chargedId,
      driverId,
      fuelQty: 0,
      refNo,
      isPayment: "true",
      activeStatus,
      customerId: customerId,
      paymentMode: GOPAL_SNACKS? paymentModeOfGopal : paymentMode,
      files: tripPaymentFile,
    };
    console.log("args", args);
    setIsSubmit(true);

    ApiIndentHandler.manageIndentPayments(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const onUploadFile = (e: any, f: any) => {
    console.log("onUploadFile: ", e, f);
    const file: any = e.target.files[0];
    if (file.size / 1024 / 1024 > CONFIG.MAX_FILE_SIZE) {
      COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.FILE_SIZE_EXCEEDED);
      return;
    }
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let base64: any = reader.result;
      setUploading(true);
      uploadFile(file, base64).then((res) => {
        setUploading(false);
      });
    };
    reader.onerror = (error) => {
      console.log("uploadFile: Error:", error);
    };
  };

  const uploadFile = async (file: any, base64 = "") => {
    const args = {
      recordRefId: 1,
      file: {
        name: file.name,
        data: base64.replace("data:", "").replace(/^.+,/, ""),
        type: file.type,
        mimeType: file.name.split(".")[1],
        size: file.size,
      },
      category: "fuel",
    };
    let fileInfo = null;
    try {
      const res = await ApiIndentHandler.fileUpload(args);
      console.log("uploadFile: ", args, res);
      const response: any = res.response;
      if (res.status === 200) {
        fileInfo = response;
        setTripPaymentFile([...tripPaymentFile, fileInfo]);
        (document.getElementById("uploadFile") as HTMLInputElement).value =
          null;
      }
    } catch (error) {}
    return fileInfo;
  };

  const handleTripChange = (e, f) => {
    const trip = indentGroup.find((r) => r.id === f.id);
    console.log("trip:", trip, indentGroup);
    console.log("f data:", f);
    if (trip) {
      setSelectedDriver(null);
      setTimeout(() => {
        setSelectedDriver({
          id: trip.data.driverId,
          label: trip.data.driverName,
        });
      }, 150);
    } else {
      setSelectedDriver(null);
      setTimeout(() => {
        setSelectedDriver({});
      }, 150);
    }
  };

  const getUploadedFiles = (ledgerId) => {
    const args = {
      ledgerId,
    };
    setUploading(true);
    setTripPaymentFile([]);
    ApiIndentHandler.getIndentLedgerFileInfo(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        setTripPaymentFile(list);
        setUploading(false);
      }
    });
  };

  return (
    <UiDialog
      title={
        defaultValues.id
          ? "Add " + LABELS.TRIP_PAYMENT + " : " + defaultValues.indentGroup
          : selectedRow.id
          ? "Edit  " + LABELS.TRIP_PAYMENT + " : " + selectedRow.indentNo
          : "Add " + LABELS.TRIP_PAYMENT
      }
      open={true}
      size={"sm"}
      onClose={() => {
        setSelectedRow({});
        setManageDialog(false);
      }}
    >
      <div className="flexColumn">
        <div className="formGroup red">
          <label>
            {LABELS.TRIP}
            {<span>{" *"}</span>}
          </label>
          <AutoComplete
            id={"indentNo"}
            list={indentGroup}
            childRef={indentIdRef}
            onChange={handleTripChange}
            defaultValue={
              defaultValues.indentId
                ? {
                    id: defaultValues.indentId,
                    label: defaultValues.indentGroup,
                  }
                : selectedRow.indentId
                ? {
                    id: selectedRow.indentId,
                    label: selectedRow.indentNo,
                  }
                : null
            }
            disabled={defaultValues.indentId || isSubmit}
          />
        </div>
        <div className="formGroup red">
          <TxtRow
            id={"paymentDate"}
            label={LABELS.TRANSACTION_DATE}
            defaultValue={
              selectedRow.paymentDateUnformatted
                ? DateFunctions.getFormatedDate(
                    selectedRow.paymentDateUnformatted,
                    FORMATS.SQL_DATE,
                    FORMATS.SQL_DATE
                  )
                : DateFunctions.getDate("now", "from", FORMATS.SQL_DATE)
            }
            disabled={isSubmit}
            type={"datetime-local"}
            required={true}
          />
        </div>
        <div className="formGroup red">
          <label>
            {LABELS.DRIVERS_NAME}
            {<span>{" *"}</span>}
          </label>
          {selectedDriver && (
            <AutoComplete
              id={"driverId"}
              list={drivers}
              childRef={driverIdRef}
              defaultValue={
                defaultValues.driverId
                  ? {
                      id: defaultValues.driverId,
                      label: defaultValues.driverName,
                    }
                  : selectedDriver.id
                  ? selectedDriver
                  : null
              }
              disabled={defaultValues.driverId || isSubmit}
            />
          )}
        </div>
        <div className="formGroup ">
          <label>{LABELS.CUSTOMER}</label>
          <AutoComplete
            list={customers}
            childRef={customerIdRef}
            defaultValue={
              selectedRow.customerId
                ? {
                    id: selectedRow.customerId,
                    label: selectedRow.customerName,
                  }
                : null
            }
            disabled={isSubmit}
          />
        </div>
        <div className="formGroup red">
          <label>
            {LABELS.CATEGORY}
            {<span>{" *"}</span>}
          </label>
          <AutoComplete
            id={"chargesType"}
            list={chargesType}
            childRef={chargedIdRef}
            defaultValue={
              selectedRow.id
                ? {
                    id: selectedRow.chargedId,
                    label: selectedRow.chargesName,
                  }
                : null
            }
          />
        </div>
        <div className="formGroup">
          <TxtRow
            id={"remarks"}
            label={LABELS.REMARKS}
            defaultValue={selectedRow.remarks}
            disabled={isSubmit}
          />
        </div>
        <div className="formGroup red">
          <TxtRow
            id={"amount"}
            label={LABELS.AMMOUNT}
            defaultValue={
              selectedRow.id
                ? Number(selectedRow.amount).toString()
                : selectedRow.amount
            }
            disabled={isSubmit}
            type={"number"}
            required={true}
          />
        </div>

        <div className="formGroup">
          <TxtRow
            id={"refNo"}
            label={LABELS.REFERENCE_NUMBER}
            defaultValue={selectedRow.refNo}
            disabled={isSubmit}
          />
        </div>

        {GOPAL_SNACKS ? (
          <div className="formGroup red">
            <label>
              {LABELS.TRANSACTION_MODE_OF_GOPAL}
              {<span>{" *"}</span>}
            </label>
            <RadioBtn
              list={[
                {
                  id: "0",
                  label: LABELS.RAJKOT,
                  value: LABELS.RAJKOT,
                  checked: selectedRow.id
                    ? selectedRow.paymentMode === "RAJKOT"
                    : true,
                  disabled: false,
                },
                {
                  id: "1",
                  label: LABELS.MODASA,
                  value: LABELS.MODASA,
                  checked: selectedRow.id
                    ? selectedRow.paymentMode === "MODASA"
                    : false,
                  disabled: false,
                },
                {
                  id: "2",
                  label: LABELS.NAGPUR,
                  value: LABELS.NAGPUR,
                  checked: selectedRow.id
                    ? selectedRow.paymentMode === "NAGPUR"
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"transactionModeOfGopal"}
              disabled={isSubmit}
            />
          </div>
        ) : (
          <div className="formGroup red">
            <label>
              {LABELS.TRANSACTION_MODE}
              {<span>{" *"}</span>}
            </label>
            <RadioBtn
              list={[
                {
                  id: "0",
                  label: LABELS.CASH,
                  value: LABELS.CASH,
                  checked: selectedRow.id
                    ? selectedRow.paymentMode === "CASH"
                    : true,
                  disabled: false,
                },
                {
                  id: "1",
                  label: LABELS.BANK,
                  value: LABELS.BANK,
                  checked: selectedRow.id
                    ? selectedRow.paymentMode === "BANK"
                    : false,
                  disabled: false,
                },
                {
                  id: "2",
                  label: LABELS.UPI,
                  value: LABELS.UPI,
                  checked: selectedRow.id
                    ? selectedRow.paymentMode === "UPI"
                    : false,
                  disabled: false,
                },
                {
                  id: "3",
                  label: LABELS.CARD,
                  value: LABELS.CARD,
                  checked: selectedRow.id
                    ? selectedRow.paymentMode === "CARD"
                    : false,
                  disabled: false,
                },
                {
                  id: "4",
                  label: LABELS.NONE,
                  value: LABELS.NONE,
                  checked: selectedRow.id
                    ? selectedRow.paymentMode === "NONE"
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"transactionMode"}
              disabled={isSubmit}
            />
          </div>
        )}

        <div className="formGroup">
          <label>{LABELS.ACTIVE_STATUS}</label>
          <RadioBtn
            list={[
              {
                id: "0",
                label: LABELS.ACTIVE,
                value: "Yes",
                checked: selectedRow.id
                  ? selectedRow.activeStatus === "Yes"
                  : true,
                disabled: false,
              },
              {
                id: "1",
                label: LABELS.INACTIVE,
                value: "No",
                checked: selectedRow.id
                  ? selectedRow.activeStatus === "No"
                  : false,
                disabled: false,
              },
            ]}
            row={true}
            name={"activeStatus"}
            disabled={isSubmit}
          />
        </div>

        <div className="formGroup">
          <label>
            {LABELS.FILE_UPLOAD}
            <small>
              {" ( Max File Size: " + CONFIG.MAX_FILE_SIZE + " MB )"}
            </small>
          </label>
          <TxtBox
            type={"file"}
            id="uploadFile"
            // defaultValue={selectedRow.id ? selectedRow.fuelFiles : null}
            className="uploadFile"
            accept="image/*,.pdf"
            onChange={onUploadFile}
          />
          <div
            className="formGroup"
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
            }}
          >
            {tripPaymentFile.map((u, i) => {
              return (
                <div className="thumbnailBox width20">
                  <IconButton
                    className="thumbnailBoxIcon"
                    onClick={() => {
                      const list = tripPaymentFile.filter((a, j) => j !== i);
                      setTripPaymentFile(list);
                    }}
                  >
                    <IconClose />
                  </IconButton>
                  <img
                    onClick={() =>
                      window.open(API_CONFIG.API_URL + u.path, "_blank")
                    }
                    src={
                      u.mimeType === "pdf"
                        ? thumbnailImg
                        : API_CONFIG.STATIC_URL + u.path
                    }
                    className="responsive cursor"
                  />
                </div>
              );
            })}
            {uploading && (
              <div className="thumbnailBox width20">
                <SkeletonBox height={150} />
              </div>
            )}
          </div>
        </div>
      </div>

      {/* mandatoryResults */}
      {mandatoryResults.length > 0 && (
        <div className="mandatoryBox">
          <ul>
            {mandatoryResults.map((m) => {
              return (
                <li>
                  <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                </li>
              );
            })}
          </ul>
        </div>
      )}
      <div className="formGroup submitBtnWrapper">
        <div className="flexbtnjustify">
          <Btn
            text={LABELS.CANCEL}
            bgColor={COLORS.RELOAD_EXPORT}
            color={COLORS.RELOAD_EXPORT_TEXT}
            onClick={() => {
              setSelectedRow({});
              setManageDialog(false);
              // setMandatoryResults([]);
            }}
          />
          <Btn
            text={LABELS.SAVE}
            onClick={manageRecord}
            bgColor={COLORS.SAVE_GREEN}
            loading={isSubmit}
          />
        </div>
      </div>
    </UiDialog>
  );
};
export default withSnackbar(TripPaymentForm);
